export default __webpack_public_path__ + "static/assets/d012da76b57d0653a25c754b488dc329.png";